// Normalisation, détection "photo" et isGibberish
export const normalizeText = (text = "") =>
  text
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();

export const containsPhotoKeyword = (text) => {
  const norm = normalizeText(text);
  return /(p+h*o+t+o+|f+o+t+o+)/.test(norm);
};

export const isGibberish = (text = "") => {
  if (!text || text.trim().length === 0) return true;

  const clean = text.replace(/[^a-zA-Z]/g, "").toLowerCase();
  if (clean.length < 2) return true;

  const vowels = "aeiouyàâäéèêëîïôöùûü";
  const consonants = "bcdfghjklmnpqrstvwxz";

  // Vérifie si le mot contient au moins une voyelle
  const hasVowel = [...clean].some((c) => vowels.includes(c));
  if (!hasVowel) return true;

  // Vérifie si le mot est une simple répétition (ex: "aaaa", "bbbb")
  if (/^(.)\1+$/.test(clean)) return true;

  // Vérifie si c'est un mot très improbable (ex: cfvedvqa)
  // 1. Taux de voyelles trop bas
  const vowelCount = [...clean].filter((c) => vowels.includes(c)).length;
  const vowelRatio = vowelCount / clean.length;
  if (vowelRatio < 0.2) return true;

  // 2. Trop de consonnes consécutives (ex: "cfvdvqa")
  if (/[bcdfghjklmnpqrstvwxyz]{5,}/i.test(clean)) return true;

  // 3. Le mot est très long mais ne ressemble à rien (seuil arbitraire)
  if (clean.length > 12 && vowelRatio < 0.3) return true;

  return false;
};

export const isHowAreYou = (text = "") => {
  const norm = text
    .normalize("NFD") // enlève accents
    .replace(/[\u0300-\u036f]/g, "") // caractères accentués
    .toLowerCase()
    .replace(/[^a-z\s]/g, "") // enlève tout sauf lettres et espaces
    .replace(/\s+/g, " ") // espaces multiples → 1 seul
    .trim();

  const patterns = [
    "ca va",
    "cava",
    "cv",
    "comment tu vas",
    "comment tu va",
    "comment vas tu",
    "comment vas toi",
    "comment vas",
    "comment ca va",
    "comment cava",
    "comment allez vous",
    "vas tu bien",
    "tu vas bien",
    "ça va",
    "sa va",
  ];

  return patterns.includes(norm);
};
